import React from "react";
import { RCCGrid, RCCIcon, RCCInput, RCCSelectOptionsCard } from "react-common-components";
import { Control, FieldErrors, FieldValues, UseFormRegister, UseFormSetValue } from "react-hook-form";
import DateTimePickerRange from "src/components/DateTimePickerRange";
import LovSectors from "src/components/Lov/Sectors";
import LovUsers from "src/components/Lov/Users";
import { useTranslation } from "src/context/Translations/context";
import { IObjective } from "./interface";
import periodsObjectives from "./periodsObjectives";

interface IFormSimplifiedFields{
    controlAddOrChange: Control<FieldValues>;
	registerAddOrChange: UseFormRegister<FieldValues>;
	errorsAddOrChange: FieldErrors<FieldValues>;
	setValueAddOrChange: UseFormSetValue<FieldValues>;
	isAdd: boolean;
	selectedObjective: IObjective;
	simpleForm: boolean;
	disabled: boolean;
}

const FormSimplifiedFields: React.FC<IFormSimplifiedFields> = ({
	controlAddOrChange,
	registerAddOrChange,
	errorsAddOrChange,
	setValueAddOrChange,
	isAdd,
	selectedObjective,
	simpleForm,
	disabled
}) => {
	const { translate } = useTranslation();
	return (
		<>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<RCCGrid
					container
					item
					xs={12}
					sm={6}
				>
					<RCCInput 
						register={registerAddOrChange}
						name="oka001Codigo"
						label={translate("Código")}
						maxLength={40}
						defaultValue={selectedObjective.oka001Codigo}
						error={errorsAddOrChange.oka001Codigo}
						disabled={disabled}
					/>
				</RCCGrid>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<RCCInput 
					register={registerAddOrChange}
					name="oka001Titulo"
					label={translate("Título")}
					maxLength={200}
					defaultValue={selectedObjective.oka001Titulo}
					error={errorsAddOrChange.oka001Titulo}
					required
					disabled={disabled}
				/>
			</RCCGrid>
			<input 
				type="text"
				defaultValue={selectedObjective.oka001Periodo}
				{...registerAddOrChange("oka001Periodo")} 
				style={{ display: "none" }} 
				readOnly
			/>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<DateTimePickerRange 
					type="datePicker"
					label={translate("Período")}
					labelSeparator={translate("até")}
					nameInit="oka001Dtinicio"
					nameEnd="oka001Dtfim"
					defaultValueEnd={isAdd ? new Date(new Date().getFullYear(), 11, 31) : selectedObjective.oka001Dtfim}
					defaultValueInit={isAdd ? new Date(new Date().getFullYear(), 0, 1) : selectedObjective.oka001Dtinicio}
					control={controlAddOrChange}
					setValue={setValueAddOrChange}
					error={errorsAddOrChange.oka001Dtfim || errorsAddOrChange.oka001Dtinicio}
					periods={periodsObjectives(translate)}
					onAccept={() => setValueAddOrChange("oka001Periodo", "")}
					onChange={() => setValueAddOrChange("oka001Periodo", "")}
					getPeriodLabelOnSelection={(label: string) => setValueAddOrChange("oka001Periodo", label)}
					required
					props={{
						datePicker: {
							disabled
						}
					}}
				/>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<RCCSelectOptionsCard 
					control={controlAddOrChange}
					name="oka001Nivel"
					label={translate("Nível")}
					options={[{
						value: "1",
						label: translate("Organizacional"),
						icon: <RCCIcon name="building" />
					},
					{
						value: "2",
						label: translate("Equipe"),
						icon: <RCCIcon name="users" />
					},
					{
						value: "3",
						label: translate("Individual"),
						icon: <RCCIcon name="user" />
					}
					]}
					defaultValue={selectedObjective.oka001Nivel ? selectedObjective.oka001Nivel.toString() : "1"}
					disabled={disabled}
				/>
			</RCCGrid>
			{simpleForm && (
				<>
					<RCCGrid
						container
						item
						xs={12}
						sm={10}
						md={8}
						lg={6}
					>
						<LovUsers 
							control={controlAddOrChange}
							name="oka001Efa005Id"
							label={translate("Responsável")}
							defaultValue={selectedObjective.oka001Efa005Id ? selectedObjective.oka001Efa005Id.toString() : ""}
							required
							disabled={disabled}
						/>
					</RCCGrid>
					<RCCGrid
						container
						item
						xs={12}
						sm={10}
						md={8}
						lg={6}
					>
						<LovUsers 
							control={controlAddOrChange}
							name="oka001Efa005Id2"
							label={translate("Autoridade")}
							defaultValue={selectedObjective.oka001Efa005Id2 ? selectedObjective.oka001Efa005Id2.toString() : ""}
							required
							disabled={disabled}
						/>
					</RCCGrid>
				</>
			)}
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<LovSectors 
					control={controlAddOrChange}
					name="oka001Taa001Id"
					label={translate("Setor")}
					defaultValue={selectedObjective.oka001Taa001Id ? selectedObjective.oka001Taa001Id.toString() : undefined}
					isCreatable
					disabled={disabled}
				/>
			</RCCGrid>
		</>
	);
};

export default FormSimplifiedFields;
